export const ORDER_STATUS = {
  CONFIRMATION: {
    value: 'CONFIRMATION',
    label: 'Confirmation',
    subValue: ['AWAITING_CONFIRMATION', 'CONFIRMED'],
  },
  PROCESSING: {
    value: 'PROCESSING',
    label: 'Processing',
    subValue: ['PICKING', 'PACKING', 'READY_TO_HANDOVER', 'READY_TO_PICK'],
  },
  DELIVERING: {
    value: 'DELIVERING',
    label: 'Delivering',
    subValue: [
      'DELIVERING',
      'FAILED_DELIVERY',
      'RETURNING',
      'LOST',
      'REJECTED',
    ],
  },
  FAIL_QC: {
    value: 'FAIL_QC',
    label: 'Fail QC',
    subValue: ['FAIL_QC'],
  },
  PENDING: {
    value: 'PENDING',
    label: 'Pending',
    subValue: [
      'MANUALLY_PENDING',
      'AUTOMATICALLY_PENDING',
      'EXCHANGE_PENDING',
      // 'PENDING_FOR_TAB_TRY_BUY',
    ],
  },
};
